import classNames from 'classnames';
import Icon, { IconProps } from '../../Atoms/Icon';
import Title from '../../Atoms/Title';

export interface Props {
  title: string;
  icon: IconProps;
  color?: 'blue' | 'white';
  className?: string;
}

function CardIcon({
  title,
  icon,
  color = 'blue',
  className
}: Props) {
  return (
    <div
      className={classNames([
        'mx-auto flex max-w-md flex-col items-center gap-5',
        className
      ])}
    >
      <div className="flex w-full items-center justify-center lg:w-24">
        <Icon
          icon={icon}
          className={classNames([
            'h-[30px] w-[30px] text-sl-indigo',
            color === 'white' && 'text-white'
          ])}
        />
      </div>
      <div className="flex w-full flex-col gap-3 text-center">
        <Title
          as="h4"
          size={6}
          color={color}
          weight={500}
          className="leading-none md:leading-none lg:leading-none"
        >
          <span className="text-sm lg:text-base">
            {title}
          </span>
        </Title>
      </div>
    </div>
  );
}

export default CardIcon;
